import { Form, Select, Button, DatePicker, Row, Col } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import { getButtonDisabled } from "../../utilities/helpers";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getDetails,
  setTemplates
}) => {
  const disabledDate = (current) => {
    return current > dayjs().endOf("day");
  };
  return (
    <div className="w-full px-8 py-6">
      <Row className="" gutter={18}>
        <Col xs={24} md={6}>
          <Form.Item
            name="Company"
            label="Company"
            colon={false}
            layout="vertical"
          >
            <Select
              style={{ minWidth: 250 }}
              size="middle"
              value={get(filter, "company")}
              placeholder="Select Company"
              options={map(get(config, "companies"), (company) => ({
                label: get(company, "name"),
                value: get(company, "id"),
              }))}
              optionFilterProp="label"
              showSearch
              onChange={(val) => {
                const company = find(get(config, "companies"), ["id", val]);
                setFilters({
                  ...filter,
                  templateType: undefined,
                  company,
                });
                setConfig({
                  ...config,
                  template_types: get(company, "template_access_list"),
                });
                form.setFieldsValue({
                  template_type: undefined,
                });
                setTemplates([])
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={6}>
          <Form.Item
            name="template_type"
            label="Template Type"
            colon={false}
            layout="vertical"
          >
            <Select
              style={{ minWidth: 250 }}
              size="middle"
              placeholder="Type"
              options={map(get(config, "template_types"), (templateType) => ({
                label: get(templateType, "name"),
                value: get(templateType, "value"),
              }))}
              value={get(filter, "templateType")}
              onChange={(value) => {
                setFilters({
                  ...filter,
                  templateType: value,
                });
                setTemplates([])
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={4}>
          <Form.Item
            initialValue={get(filter, "date")}
            name="date"
            label="Date"
            colon={false}
            layout="vertical"
          >
            <DatePicker
              format={"DD/MM/YYYY"}
              onChange={(value, dateString) => {
                setFilters({
                  ...filter,
                  date: value,
                });
              }}
              value={get(filter, "date")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={6}>
          <Form.Item name="submit" label=" " colon={false} layout="vertical">
            <Button
              type="primary"
              className="w-30"
              onClick={() =>
                getDetails({
                  company_uuid: get(filter, "company.id"),
                  type: get(filter, "templateType"),
                  date: dayjs(get(filter, "date")).format("YYYY-MM-DD"),
                })
              }
              disabled={getButtonDisabled(filter, [
                "templateType",
                "company",
                "date",
              ])}
            >
              Submit
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default HeaderSelector;
